import React from 'react';
import styles from './CadFIsInformation.module.scss';
import {
  CadAddressValueType,
  CadFIValueType,
  CadPersonValueType,
  CadPremiseValueType,
  CadSubjectValueType
} from '../../../../../Models/CadReportValue';
import {
  FieldItemList,
  FieldItemListType
} from '../../CommonBody/FieldItemList/FieldItemList';
import {
  getCADAddressFull,
  getCADPersonnelFullName,
  getCADPremiseName,
  getCADSubjectFullName
} from '../../CommonBody/Helpers';

const getFIFields = (
  fi: CadFIValueType,
  premises: CadPremiseValueType[],
  adddresses: CadAddressValueType[],
  personnel: CadPersonValueType[],
  subjects: CadSubjectValueType[]
): FieldItemListType[] => {
  let fiFields: FieldItemListType[] = [];

  fiFields = [
    {
      label: 'Case Number',
      value: fi.case_number,
      type: 'string'
    },
    {
      label: 'Agency',
      value: fi.agency,
      type: 'string'
    }
  ];

  if (fi.subject_id) {
    fiFields.push({
      label: 'Subject',
      value: getCADSubjectFullName(fi.subject_id, subjects),
      type: 'string'
    });
  }

  fiFields = [
    ...fiFields,
    {
      label: 'Type',
      value: fi.type,
      type: 'string'
    },
    {
      label: 'Date and Time',
      value: fi.date_time,
      type: 'datetime'
    }
  ];

  if (fi.premise_id) {
    fiFields.push({
      label: 'Premise',
      value: getCADPremiseName(fi.premise_id, premises),
      type: 'string'
    });
  }

  if (fi.address_id) {
    fiFields.push({
      label: 'Address',
      value: getCADAddressFull(
        fi.address_id,
        adddresses as CadAddressValueType[]
      ),
      type: 'string'
    });
  }

  if (fi.officer_badge_id) {
    fiFields.push({
      label: 'Officer',
      value: getCADPersonnelFullName(
        fi.officer_badge_id,
        personnel as CadPersonValueType[]
      ),
      type: 'string'
    });
  }

  return [
    ...fiFields,
    {
      label: 'Narrative',
      value: fi.narrative,
      type: 'string'
    },
    {
      label: 'Notes',
      value: fi.notes,
      type: 'string'
    }
  ];
};

export interface CadFIsInformationProps {
  fis?: CadFIValueType[];
  premises?: CadPremiseValueType[];
  addresses?: CadAddressValueType[];
  personnel?: CadPersonValueType[];
  subjects?: CadSubjectValueType[];
}

export const CadFIsInformation = ({
  fis,
  premises,
  addresses,
  personnel,
  subjects
}: CadFIsInformationProps): React.ReactElement<CadFIsInformationProps> => {
  return (
    <div className={styles.cadFIsInformation}>
      <h3 className={styles.title}>Field Intelligence Information</h3>
      <div className={styles.items}>
        {fis?.map((fi, index) => (
          <FieldItemList
            key={fi.id}
            title={`${index === 0 ? fi.number : ''}`}
            fields={getFIFields(
              fi as CadFIValueType,
              premises as CadPremiseValueType[],
              addresses as CadAddressValueType[],
              personnel as CadPersonValueType[],
              subjects as CadSubjectValueType[]
            )}
            hasDivider={index < fis.length - 1}
          />
        ))}
      </div>
    </div>
  );
};
